export enum NavigationPanelGroupingOptionType {
  HIERARCHY = 'Hierarchy',
  FLATTEN = 'Flatten',
  CUSTOM = 'Custom',
  NONE = 'None',
}

export enum NavigationPanelGroupingOption {
  /**
   * Default VIEW grouping for Portfolios and Benchmarks when item count exceeds the pin cap.
   * See `getDefaultViewGroupingConfig`.
   */
  STRATEGY_ASSET_CLASS = 'Asset Class',
  STRATEGY_CURRENCY = 'Currency',
  /**
   * Default VIEW grouping for QIS Baskets when item count exceeds the pin cap.
   */
  STRATEGY_FACTOR = 'Factor',
  STRATEGY_PROVIDER = 'Provider',
  STRATEGY_REGION = 'Region',
  STRATEGY_RETURN_TYPE = 'Return Type',
  STRATEGY_STYLE = 'Style',
  STRATEGY_TYPE = 'Type',

  // plus custom properties on strategies that users have

  /**
   * Default VIEW grouping for Equity Baskets when item count exceeds the pin cap.
   */
  CONSTITUENT_SECTOR = 'Sector',
  CONSTITUENT_COUNTRY = 'Country',
  CONSTITUENT_LONG_SHORT = 'Long/Short',

  /**
   * TODO: WAA-13029 - confirm that the following are not yet implemented in the API
   */
  // CONSTITUENT_CURRENCY = 'Constituent Currency',
  // CONSTITUENT_REGION = 'Constituent Region',
  // CONSTITUENT_PRODUCT_TYPE = 'Constituent Product Type',
}

/**
 * Grouping options for Portfolios, QIS Baskets, Benchmarks, and Peer Groups
 */
export enum PortfolioNavigationPanelGroupingOption {
  STRATEGY_ASSET_CLASS = NavigationPanelGroupingOption.STRATEGY_ASSET_CLASS,
  STRATEGY_CURRENCY = NavigationPanelGroupingOption.STRATEGY_CURRENCY,
  STRATEGY_FACTOR = NavigationPanelGroupingOption.STRATEGY_FACTOR,
  STRATEGY_PROVIDER = NavigationPanelGroupingOption.STRATEGY_PROVIDER,
  STRATEGY_REGION = NavigationPanelGroupingOption.STRATEGY_REGION,
  STRATEGY_RETURN_TYPE = NavigationPanelGroupingOption.STRATEGY_RETURN_TYPE,
  STRATEGY_STYLE = NavigationPanelGroupingOption.STRATEGY_STYLE,
  STRATEGY_TYPE = NavigationPanelGroupingOption.STRATEGY_TYPE,
}

export enum EquityBasketAndThematicNavigationPanelGroupingOption {
  CONSTITUENT_SECTOR = NavigationPanelGroupingOption.CONSTITUENT_SECTOR,
  CONSTITUENT_COUNTRY = NavigationPanelGroupingOption.CONSTITUENT_COUNTRY,
  CONSTITUENT_LONG_SHORT = NavigationPanelGroupingOption.CONSTITUENT_LONG_SHORT,

  // TODO: WAA-13029 -confirm that the following are not yet implemented in the API
  // CONSTITUENT_CURRENCY = NavigationPanelGroupingOption.CONSTITUENT_CURRENCY,
  // CONSTITUENT_REGION = NavigationPanelGroupingOption.CONSTITUENT_REGION,
  // CONSTITUENT_PRODUCT_TYPE = NavigationPanelGroupingOption.CONSTITUENT_PRODUCT_TYPE,

  /**
   * The following strategy grouping options exist in the platform today, but not in Christophe's Confluence
   * TODO: WAA-13029 - confirm that we actually want to show all these strategy grouping options for Equity Baskets and Thematics
   */
  STRATEGY_ASSET_CLASS = NavigationPanelGroupingOption.STRATEGY_ASSET_CLASS,
  STRATEGY_CURRENCY = NavigationPanelGroupingOption.STRATEGY_CURRENCY,
  STRATEGY_FACTOR = NavigationPanelGroupingOption.STRATEGY_FACTOR,
  STRATEGY_PROVIDER = NavigationPanelGroupingOption.STRATEGY_PROVIDER,
  STRATEGY_REGION = NavigationPanelGroupingOption.STRATEGY_REGION,
  STRATEGY_RETURN_TYPE = NavigationPanelGroupingOption.STRATEGY_RETURN_TYPE,
  STRATEGY_STYLE = NavigationPanelGroupingOption.STRATEGY_STYLE,
  STRATEGY_TYPE = NavigationPanelGroupingOption.STRATEGY_TYPE,
}
